// Interfaces
import { IButtonSelector } from "./interfaces";

// Layouts
import SimpleDoubleChecking from "@Layouts/components/Buttons/SimpleDoubleChecking";
import SimpleIconButton from "@Layouts/components/Buttons//SimpleIconButton";

// MUI
import { Grid, Skeleton, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";

export default function ButtonSelector(props: Readonly<IButtonSelector>) {
	const {
		icon,
		iconHover,
		color = "",
		confirmationButtonColor = "",
		classes = "",
		loadingIcon = "",
		disabled = false,
		isDoubleChecking = false,
		loading = false,
		loadingAction = false,
		onActionClick = () => {},
	} = props;

	if (loading) {
		return (
			<Grid sx={{ padding: "10px" }}>
				<Skeleton variant="circular" width={30} height={30} />
			</Grid>
		);
	}

	if (isDoubleChecking) {
		return (
			<SimpleDoubleChecking
				className={classes}
				color={color}
				confirmationButtonColor={confirmationButtonColor}
				icon={icon}
				iconHover={iconHover}
				loadingIcon={loadingIcon}
				loading={loadingAction}
				confirmationIcon={
					<SvgIcon
						viewBox="-2 -2 17 17"
						className="!text-gray-blue [&>path]:!fill-gray-blue !text-[30px]"
						component={TrashIcon}
					/>
				}
				disabled={disabled}
				onDeleteAction={onActionClick}
			/>
		);
	}

	return (
		<SimpleIconButton
			className={classes}
			color={color}
			icon={icon}
			iconHover={iconHover}
			loadingIcon={loadingIcon}
			loading={loadingAction}
			disabled={disabled}
			onClick={onActionClick}
		/>
	);
}
